<template>
  <div class="contact">
    <div class="headImg">
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="content">
      <!-- <p class="title">联系我们</p>
      <p class="subTitle">CONTACT US</p> -->
      <div class="list">
        <div class="map">
          <!-- <img src="../../assets/about/map.png" alt=""> -->
          <baidu-map
            class="map-view"
            :scroll-wheel-zoom="true"
            :zoom="map.zoom"
            :center="{ lng: map.center.lng, lat: map.center.lat }"
          >
            <bml-marker-clusterer :averageCenter="true">
              <bm-marker
                :position="{ lng: map.center.lng, lat: map.center.lat }"
              ></bm-marker>
            </bml-marker-clusterer>
            <bm-info-window
              :position="{ lng: map.center.lng, lat: map.center.lat }"
              title="泰立智汇科技有限公司"
              :show="map.show"
            >
              <p>青羊工业园区K13</p>
            </bm-info-window>
          </baidu-map>
        </div>
        <div class="form">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="60px"
            class="demo-ruleForm"
            size="small"
            style="display: flex; flex-wrap: wrap"
          >
            <el-form-item label="姓名" style="width: 50%" prop="name"
              :rules="[
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
              ]"
            >
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="电话" style="width: 50%" prop="tell"
              :rules="[
                { required: true, message: '请填写电话号码', trigger: 'blur' },
                { min: 11, max: 11, message: '电话号码为11位', trigger: 'blur' }
              ]"
            >
              <el-input v-model="ruleForm.tell"></el-input>
            </el-form-item>
            <el-form-item 
              label="邮箱"
              prop="email"
              style="width: 50%"
              :rules="[
                { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                { type: 'email', message: '注意邮箱格式', trigger: ['blur', 'change'] }
              ]"
            >
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="公司" style="width: 50%">
              <el-input v-model="ruleForm.company"></el-input>
            </el-form-item>
            <el-form-item label="留言" style="width: 100%" prop="content"
              :rules="[
                { required: true, message: '留言类容不能为空！', trigger: 'blur' }
              ]"
            >
              <el-input
                type="textarea"
                v-model="ruleForm.content"
                rows="8"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%">
              <el-button
                style="width: 100%"
                type="primary"
                @click="submitForm('ruleForm')"
                >发送</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: "contact",
  data() {
    return {
      headImg:"",
      ruleForm: {
        name: "",
        tell: "",
        email: "",
        company: "",
        content: "",
      },
      map: {
        center: { lng: 103.964505, lat: 30.691804 }, // '西安市',
        zoom: 12,
        show: true,
      },
      baseURL:null,
    };
  },
  components: {},
  mounted () {
    this.baseURL = baseURL
    this.getheadImg()
  },
  methods: {
    // 获取大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/contact`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    submitForm(formName) {
      // console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendMeesage();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    sendMeesage() {
      this.$http
        .post(`${baseURL}/json/saveBoard`, this.ruleForm)
        .then((res) => {
          // console.log(res, "留言结果");
          if (res.status == 200) {
            this.ruleForm = {
              name: "",
              tell: "",
              emall: "",
              company: "",
            };
            this.$message({
              message: '留言发送成功！',
              type: 'success'
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
textarea {
  resize: none !important;
}
.contact {
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .content {
    // width: 60%;
    width: 1200px;
    padding: 50px 0%;
    margin: 0 auto;
    p.title {
      font-size: 40px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 600;
      // text-align: left;
      color: #07142b;
      line-height: 56px;
    }
    p.subTitle {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      // text-align: left;
      color: #07142b;
      line-height: 20px;
      letter-spacing: 3px;
    }
    .list {
      height: 320px;
      padding: 50px 0;
      display: flex;
      justify-content: space-between;
      .map {
        // width: 50%;
        width: 600px;
        height: 100%;
        margin-right: 20px;
        border: 1px solid #b6bbd7;
        border-radius: 4px;
        img {
          width: 100%;
          height: 100%;
        }
        .map-view {
          width: 100%;
          height: 100%;
        }
      }
      .form {
        // flex: 1;
        width: 580px;
        height: 100%;
      }
    }
  }
}
</style>